import React, {
    useContext,
    useState,
    useEffect,
} from 'react';
import { useMutation } from '@tanstack/react-query';

import { getBasketData, refetchBasketData, NotificationContext, handleError } from '../router'

import * as OPTIONS from "../option-fields";
import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';

const fundId = OPTIONS.donationUpsell.fund?.innerHTML;
const amountFrom = parseInt(OPTIONS.donationUpsell.amount_from);
const amountTo = parseInt(OPTIONS.donationUpsell.amount_to);
const amountDonation = parseInt(OPTIONS.donationUpsell.amount_donation).toFixed(2);
let donationAutoAdded = false;

export default function DonationPrompt(props) {

    const {notification, setNotification} = useContext(NotificationContext);
    const { data: basketData, isPending: basketDataPending, isFetching: basketDataFetching } = getBasketData();

    const [displayPrompt, setDisplayPrompt] = useState(false);
    const [donationId, setDonationId] = useState(null);
    const [pending, setPending] = useState(false);

    const addDonation = useMutation({
        mutationFn: () => QUERIES.addDonation([{Amount: amountDonation, FundId: fundId}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    });

    const removeDonation = useMutation({
        mutationFn: () => QUERIES.removeDonation([donationId]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    });

    useEffect(() => {
        if (!basketData) return;
        setPending(true);

        const donation_id = basketData.donations?.filter((donation) => donation.fund?.id == fundId);
        if (donation_id.length) {
            setDonationId(donation_id[0].id);
        } else {
            setDonationId(null);
        }

        // Check if basket total is within bounds to display prompt
        if ((basketData.total >= amountFrom && basketData.total <= amountTo) || donation_id.length) {
            setDisplayPrompt(true);
        }

        setPending(false)
    }, [basketData])

    useEffect(() => {
        if (!displayPrompt) return;

        if (!donationAutoAdded && !donationId) {
            donationAutoAdded = true;
            addDonation.mutateAsync();
        }

    }, [displayPrompt])

    if (!basketData || !displayPrompt || basketDataFetching || addDonation.isPending || removeDonation.isPending || pending) return;

    return (
        <section className='donation-prompt'>
            <h2 className='booking-pathway__header'>{OPTIONS.donationUpsell.title?.innerHTML}</h2>
            <div className='donation-prompt--description' dangerouslySetInnerHTML={{__html: OPTIONS.donationUpsell.introduction?.innerHTML}}></div>
            <p className={`donation-prompt--detail ${donationId ? 'donation-added' : 'donation-removed' }`}>
                <span>Donation</span>
                <span>£{amountDonation}</span>
            </p>
            {donationId ?
                <button type="button" className='donation-prompt--button' onClick={() => removeDonation.mutateAsync()}>I do not wish to donate</button>
            :    
                <button type="button" className='donation-prompt--button' onClick={() => addDonation.mutateAsync()}>I'd like to donate</button>
            }
        </section>
    );
}